/* eslint no-undef: "off" */

import 'login/main.scss';

import Rails from 'rails-ujs';

require.context('../assets/images', true);

Rails.start();
